var exports = {
  "R_": "heading__OovDPf",
  "ZY": "toggleCell__MT29Yy",
  "L$": "toggle__FME5UC",
  "Kk": "icon__7_vOGS",
  "Pf": "label__TrAkJ1",
  "qT": "features__I8WnTp",
  "sz": "expanded__tYeLLg",
};

module.exports = exports;
